import { render, staticRenderFns } from "./MemberAreaModulesEmpty.vue?vue&type=template&id=79dca93a&scoped=true&"
import script from "./MemberAreaModulesEmpty.vue?vue&type=script&lang=js&"
export * from "./MemberAreaModulesEmpty.vue?vue&type=script&lang=js&"
import style0 from "./MemberAreaModulesEmpty.vue?vue&type=style&index=0&id=79dca93a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dca93a",
  null
  
)

export default component.exports